<template>
  <BaseDialogBox v-bind="$attrs">
    <v-card :min-width="maxWidth ? '' : 360" :max-width="maxWidth ?? 500">
      <v-card-title class="pt-7 pb-3 px-5 white-space--wrap">
        <h4 class="heading-3 bold black--text">
          <slot name="confirmation-title">
            {{ CONSTANTS.DEFAULT_CONFIRMATION_TITLE }}
          </slot>
        </h4>
      </v-card-title>
      <v-card-subtitle
        class="body-1 mt-0 mb-4 px-5 py-0 black--text message-wrapper"
        style="max-width: 95%; line-height: 28px !important"
      >
        <slot name="confirmation-message">
          {{ CONSTANTS.DEFAULT_CONFIRMATION_MESSAGE }}
        </slot>
      </v-card-subtitle>
      <hr v-if="$slots['confirmation-actions']" class="separator" />
      <v-card-actions class="card-actions d-flex pb-4 px-4">
        <slot name="confirmation-actions">
          <BaseButton
            outlined
            plain
            height="40"
            class="bg-slate_100 cancel body-1 px-6 ml-auto"
            @click="$emit('cancel')"
          >
            {{ $attrs['cancellation-button-text'] ?? CONSTANTS.CANCEL }}
          </BaseButton>
          <BaseButton
            outlined
            plain
            height="40"
            class="text-white bg-orange_600 confirm body-1 px-6"
            :loading
            @click="$emit('confirm')"
          >
            {{ $attrs['confirmation-button-text'] ?? CONSTANTS.CONFIRM }}
          </BaseButton>
        </slot>
      </v-card-actions>
    </v-card>
  </BaseDialogBox>
</template>
<script setup lang="ts">
import CONSTANTS from '@/utils/constants/string-constants'
import { BaseDialogBox, BaseButton } from '../base'

defineProps<{
  maxWidth?: string | number
  loading?: boolean
}>()
</script>
<style scoped lang="scss">
.white-space--wrap {
  white-space: wrap;
}
.message-wrapper {
  white-space: pre-line;
}
</style>
